import { isEmpty } from 'lodash';
import React from 'react'
import { Card, CardHeader, Col, Table } from 'reactstrap'
import NoDataComponent from '../NoDataComponent';
const EntityShareHoldingPattern = ({ shareHoldingData }) => {

    const formatLenderName = (name) => {
        if (!name) return '-';
      
        let formattedName = name
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      
        formattedName = formattedName.replace(/\(([^)]+)\)/g, (match, p1) => {
          let transformedContent = p1
            .split(' ')
            .map(word => {
              if (word.toLowerCase() === 'nris') {
                return "NRI's";
              }
              return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');
          return `(${transformedContent})`;
        });
      
        return formattedName;
      };
    return (
            <Card style={{border:"none"}}>
                <CardHeader>
                    <div className="d-flex align-items-end">
                        <h4>Shareholding Pattern(s)</h4>
                    </div>
                </CardHeader>
                {!isEmpty(shareHoldingData) ? 
                <div className="table-responsive react-table">
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Particulars</th>
                                <th>Total</th>
                                <th>
                                    <div className='text-center w-100'>Promoters</div>
                                    <div className='d-flex w-100 justify-content-between'>
                                        <span>No. Of Shares</span>
                                        <span>Percentage</span>
                                    </div>
                                </th>
                                <th>
                                    <div className='text-center w-100'>Non-Promoters</div>
                                    <div className='d-flex w-100 justify-content-between'>
                                        <span>No. Of Shares</span>
                                        <span>Percentage</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!isEmpty(shareHoldingData) ? shareHoldingData.map((item, index) => {
                                return (
                                    <tr key={`index-${item.particulars}`}>
                                        <td>{!isEmpty(item.particulars) ? formatLenderName(item.particulars) : ''}</td>
                                        <td>{!isEmpty(item.total) ? item.total : ''}</td>
                                        <td>
                                            <div className='d-flex w-100 justify-content-between'>
                                                <span>{(!isEmpty(item.promoters) && !isEmpty(item.promoters.numberOfShares)) ? item.promoters.numberOfShares : ''}</span>
                                                <span>{(!isEmpty(item.promoters) && !isEmpty(item.promoters.percentage)) ? `${item.promoters.percentage}%` : ''}</span>
                                            </div>
                                        </td>
                                        <td >
                                            <div className='d-flex w-100 justify-content-between'>
                                                <span>{(!isEmpty(item.nonPromoters) && !isEmpty(item.nonPromoters.numberOfShares)) ? item.nonPromoters.numberOfShares : ''}</span>
                                                <span>{(!isEmpty(item.nonPromoters) && !isEmpty(item.nonPromoters.percentage)) ? `${item.nonPromoters.percentage}%` : ''}</span>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }) : <Col sm={12} className=''>
                                <NoDataComponent title='No Data' subtitle='No Data Available' />
                            </Col>}
                        </tbody>
                    </Table>
                </div>
                : <NoDataComponent title='No Data' subtitle='No Data Available' />}
            </Card>
    )
}

export default EntityShareHoldingPattern